'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';

var getFlag = function getFlag(resultGrade, resultGradeFlip) {
  if (resultGradeFlip) {
    return resultGrade ? 'fail' : 'pass';
  } else {
    return resultGrade ? 'pass' : 'fail';
  }
};

var Tag = function Tag(_ref) {
  var resultGrade = _ref.resultGrade,
      resultGradeFlip = _ref.resultGradeFlip;
  var resultGradeFlag = getFlag(resultGrade, resultGradeFlip);
  return /*#__PURE__*/_jsx("div", {
    className: "tag-wrapper",
    children: /*#__PURE__*/_jsx("div", {
      className: "tag tag-" + resultGradeFlag,
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "results.data." + resultGradeFlag
      })
    })
  });
};

export default Tag;